/* eslint-disable camelcase */
/* eslint-disable max-len */

import React from 'react';
import '../../../styles/companies.scss';

export default ({
  id, name, handleClick,
}) => {
  return (
    <div
      className="company-preview-area"
      role="button"
      tabIndex={-1}
      onClick={() => {
        handleClick(id);
      }}
    >
      <p>{`Fridge ID: ${id}`}</p>
      <p>{`Fridge Name: ${name}`}</p>
    </div>
  );
};
